import { Create, SimpleForm, TextInput, DateInput, NumberInput, BooleanInput } from 'react-admin';

export const Tbl_giornataCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="legaStagioneId" />
            <NumberInput source="numero" />
            <TextInput source="nome" />
            <DateInput source="dataInizio" />
            <DateInput source="dataFine" />
            <TextInput source="note" multiline />
            <BooleanInput source="flDisputata" defaultValue={false} />
            <BooleanInput source="flVisibile" defaultValue={true} />
            <BooleanInput source="flAttivo" defaultValue={true} />
            <BooleanInput source="flAnnullato" defaultValue={false} />
            <NumberInput source="ordinamento" />
        </SimpleForm>
    </Create>
);
